import { Grid } from 'antd';

const { useBreakpoint } = Grid;
const useIsMobile = () => {
  const screens = useBreakpoint();
  const isMobile = Boolean(screens?.xs);
  const isTablet = Boolean(screens?.sm);

  return {
    isMobile,
    isTablet,
  };
};

export default useIsMobile;
